import { render, staticRenderFns } from "./DateSuggestionTable.vue?vue&type=template&id=6f7316a3&"
import script from "./DateSuggestionTable.vue?vue&type=script&lang=js&"
export * from "./DateSuggestionTable.vue?vue&type=script&lang=js&"
import style0 from "./DateSuggestionTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7316a3')) {
      api.createRecord('6f7316a3', component.options)
    } else {
      api.reload('6f7316a3', component.options)
    }
    module.hot.accept("./DateSuggestionTable.vue?vue&type=template&id=6f7316a3&", function () {
      api.rerender('6f7316a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/calendar/calendar-event-handler/DateSuggestionTable.vue"
export default component.exports